import { render } from "./RotasTempoReal.vue?vue&type=template&id=0b4338bc&ts=true"
import script from "./RotasTempoReal.vue?vue&type=script&lang=ts"
export * from "./RotasTempoReal.vue?vue&type=script&lang=ts"

import "./RotasTempoReal.vue?vue&type=style&index=0&id=0b4338bc&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__